export const environment = {
  production: false,
  apiUrl: 'https://jeffwebapp2.azurewebsites.net',
};
